// components/GrowthBlock.jsx
import { useMemo } from "react";
import { getRandomVariant } from "./getRandomVariant";

const growthVariants = [
  ({ company, growth }) => (
    <>
      Revenue trends indicate changes in business activity over time. {company} reported sales growth of <strong>{growth}%</strong>, reflecting variation in revenue during the period under review.
    </>
  ),

  ({ company, growth }) => (
    <>
      Growth indicators help track changes in business scale. {company} recorded revenue growth of <strong>{growth}%</strong>, providing context on business performance.
    </>
  )
];

export default function GrowthBlock({ company, growth }) {
  const Variant = useMemo(
    () => getRandomVariant(growthVariants),
    []
  );
  if (!growth) return null;

  return <p className="mb-5"><Variant company={company} growth={growth} /></p>;
}
